import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [ "start", "end", "type", "category", "submit", "options", "verticals", "categories", "district", "region", "featuresLocations", "featuresLocationsOptions" ]

  initialize() {
    this.limit = 1
    this.source = null
  }

  connect() {
   this._applyListeners()
   this._typeCheck()
  }

  onTypeChange() {
    this._typeCheck()
  }

  onCategoryChange() {
    this._categoryCheck()
  }

  onDateChange() {
    const temp = this.startTarget.value
    const startDate = new Date(temp)
    const endDate = new Date(this.endTarget.value)
    if (startDate > endDate) {
      this.startTarget.value = this.endTarget.value
      this.endTarget.value = temp
    }
  }

  _applyListeners() {
    this.typeTargets.forEach((option) => {
      option.querySelector('input[type="radio"]').dataset.action = `${this.scope.identifier}#onTypeChange`
    })
  }

  _typeCheck() {
    const selected = this.selectedType
    if (selected) {
      this.limit = selected.dataset.limit
      this._renderOptions(selected.dataset.source)
      this._categoryCheck()

      if (selected.dataset.featuresLocations == 'yes') {
        const template = this.featuresLocationsTarget.innerHTML
        this.featuresLocationsOptionsTarget.innerHTML = template
      }
      else {
        this.featuresLocationsOptionsTarget.innerHTML = ""
      }
    } else {
      this.submitTarget.setAttribute('disabled', 'disabled')
    }
  }

  _categoryCheck() {
    const selected = this.selectedCategories
    if (selected.length >= this.limit) {
      // disable all the others
      this.categoryTargets.forEach((option) => {
        if (!selected.includes(option)) option.classList.add('disabled')
      })
    } else {
      this.categoryTargets.forEach((option) => option.classList.remove('disabled'))
    }

    if (selected.length != this.limit) {
      this.submitTarget.setAttribute('disabled', 'disabled')
    } else {
      this.submitTarget.removeAttribute('disabled')
    }
  }

  _renderOptions(source) {
    if (this.source !== source) {
      this.source = source
      const template = this[`${this.source}Target`].innerHTML
      this.optionsTarget.innerHTML = template
    }
  }

  get selectedType() {
    return this.typeTargets.find((option) => option.querySelector('input[type="radio"]').checked)
  }

  get selectedCategories() {
    return this.categoryTargets.filter((option) => option.querySelector('input[type="checkbox"]').checked)
  }

  checkRegion() {
    this.districtTargets.forEach((district) => { district.checked = false})
  }

  checkDistrict() {
    this.regionTargets.forEach((region) => { region.checked = false})
  }
}
